import React from 'react';
import {
  ReportsLayoutButtonWrapper,
  ReportsLayoutContainer,
  ReportsLayoutHeader,
  ReportsLayoutTitle,
} from './ReportsLayout.styled';
import { Button, Divider } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import useTranslation from 'Hooks/useTranslation';
import ConditionalRender from 'Components/ConditionalRender';

interface Props {
  title: React.ReactNode;
  buttons?: React.ReactNode;
  onExport?: () => void;
  actions?: React.ReactNode;
}

const ReportsLayout = ({ title = '', children, buttons, onExport, actions }: React.PropsWithChildren<Props>) => {
  const { t2 } = useTranslation('employees_reports');

  return (
    <ReportsLayoutContainer>
      <ReportsLayoutHeader>
        <ReportsLayoutTitle>{title}</ReportsLayoutTitle>
        <ReportsLayoutButtonWrapper>
          <ConditionalRender condition={!!buttons}>{buttons}</ConditionalRender>
          <ConditionalRender condition={!!onExport}>
            <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} onClick={onExport}>
              {t2('export')}
            </Button>
          </ConditionalRender>
          <ConditionalRender condition={!!actions}>{actions}</ConditionalRender>
        </ReportsLayoutButtonWrapper>
      </ReportsLayoutHeader>
      <Divider sx={{ margin: '1rem 0' }} />
      {children}
    </ReportsLayoutContainer>
  );
};

export default ReportsLayout;
